import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Logout } from '../redux/fetchActions/tokens';

export function TokenValidation() {
  const token = localStorage.getItem('token');
  const history = useHistory();

  useEffect(() => {
    if (token === null) {
      history.push('/login');
    }
  }, [history, token]);
}

export function checkLocalStoreJson(item: string) {
  const localStorageItem = localStorage.getItem(item);
  let result;
  if (localStorageItem !== null) {
    result = JSON.parse(localStorageItem);
  }
  return result;
}

export function gotErrorFromApi(error: any, dispatch: any, action?: any) {
  if (error.response !== undefined && error.response.data === 'Unauthorized.') {
    Swal.fire({
      icon: 'warning',
      title: 'Sua sessão encerrou!',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(action());
        dispatch(Logout());
      } else if (result.isDenied) {
        dispatch(action());
      }
    });
  } else {
    Swal.fire({
      icon: 'error',
      title: 'Erro!',
      text: 'Ocorreu um erro durante a requisição, tente novamente mais tarde!',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(action());
        // dispatch(Logout());
      }
    });
  }
}

export function gotErrorFromApiData(
  dataError: any,
  dispatch: any,
  action?: any
) {
  if (dataError === 'Unauthorized.') {
    Swal.fire({
      icon: 'warning',
      title: 'Sua sessão encerrou!',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(action());
        dispatch(Logout());
      } else if (result.isDenied) {
        dispatch(action());
      }
    });
  } else {
    Swal.fire({
      icon: 'error',
      title: 'Erro!',
      text: dataError.erro,
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(action());
      }
    });
  }
}
